export const TOAST_DISMISS_MS = 5000;
export const DEFAULT_PAGE_SIZE = 25;
